$.extend($.fn.DataTable.ext.classes, {
	sLengthSelect: "form-control form-control-sm",
});

(function($) {
	// save the original datatables function for later
	var defaultDataTables = $.fn.DataTable;
	
	$.fn.DataTable = function() {
		// only apply defaults if we are creating a DataTable.
		if(typeof arguments[0] === 'object' || arguments.length === 0) {
			var options = arguments[0] || {};
			var defaults = {
				pageLength: 10,
				lengthChange: true,
				lengthMenu: [5, 10, 25, 50, 100],
				responsive: true,
				dom: "<'row'"
						+"<'col-12 toolbar-left d-flex align-items-center justify-content-sm-start justify-content-center col-sm-6'l>"
						+"<'col-12 toolbar-right d-flex align-items-center justify-content-sm-end justify-content-center col-sm-6'f>"
					+">"
					+"<'row'<'col-sm-12'tr>>"
					+"<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
			};
			
			options = Object.assign(defaults, options);
			
			if(options.export) {
				// we want export functionality.
				options.buttons = (options.buttons || []).concat([
					{
						extend: 'excel',
						text: 'XLS',
						className: 'btn btn-default',
						exportOptions: {
							columns: 'th:not(.export-exclude)'
						}
					},
					{
						extend: 'csv',
						text: 'CSV',
						className: 'btn btn-default',
						exportOptions: {
							columns: 'th:not(.export-exclude)'
						}
					},
					{
						extend: 'pdf',
						text: 'PDF',
						className: 'btn btn-default',
						exportOptions: {
							columns: 'th:not(.export-exclude)'
						}
					},
				]);
			} else {
				options.buttons = options.buttons || [];
			}
			
			// default language settings
			options.language = Object.assign({
				processing: '<div class="d-flex justify-content-center align-items-center"><i class="fas fa-spinner fa-spin fa-2x mr-3"></i> <h3>Loading...</h3></div>',
			}, options.language);
			
			arguments[0] = options;
		}
		
		
		// call the original datatable with our arguments applied
		// binding this is important because 'this' is the object of which this function is called on.
		// $('#table').DataTable(); <- $('#table') is 'this'
		return defaultDataTables.apply(this, arguments)
	}
})(jQuery);